import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";

type canDeactivateType = Observable<boolean> | Promise<boolean> | boolean;
export interface CanComponentDeactivate {
  canDeactivate: () => canDeactivateType;
  confirmDialog: (dialog: any) => Observable<boolean>;
}
@Injectable()
export class UnsavedChangesGuard
  implements CanDeactivate<CanComponentDeactivate>
{
  constructor(private translate: TranslateService, private dialog: MatDialog) {}

  /*
  public canDeactivate(component: CanComponentDeactivate): canDeactivateType {
    if (component?.canDeactivate()) {
      return true;
    } else {
      let confirmDialog = confirm(
        this.translate.instant("TopNav.leaveDetailsWarning")
      );
      return confirmDialog;
    }
  }*/
  canDeactivate(component: CanComponentDeactivate): Observable<boolean> {
    if (!component?.canDeactivate()) {
      return component.confirmDialog(this.dialog);
    }
    //please import 'of' form 'rxjs/operators'
    return of(true);
  }
}
